import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URL } from "../../../Services/constant";

const initialState = {
    data: null,
    token: "",
    loading: false,
};

export const loginUser = createAsyncThunk(
    "/login",
    async (body) => {
        const res = await fetch(API_URL + "/login", {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json",
            },
        });
        const data = await res.json();
        return data;
    }
);

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        logout: (state) => {
            state.token = "";
            state.data = null;
            localStorage.removeItem("access_token");
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginUser.pending, (state) => {
                state.loading = true;
            })
            .addCase(loginUser.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.data = payload?.result?.user;
                state.token = payload?.result?.token;
                localStorage.setItem("access_token", payload?.result?.token);
            })
            .addCase(loginUser.rejected, (state) => {
                state.loading = false;
            });
    },
});

export const authReducer = authSlice.reducer;
export const { logout } = authSlice.actions;
